import { Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { CurrencyPipe } from '@shared/pipes/currency.pipe';

@Component({
  selector: 'app-current-package',
  standalone: true,
  imports: [CurrencyPipe, TranslatePipe],
  templateUrl: './current-package.component.html',
  styleUrl: './current-package.component.scss'
})
export class CurrentPackageComponent {
  name = input<string>();
  price = input<string>();
}
